export default ({ request }) => ({
    ecomOrderPlatformTransformTemplateListApi(data = {}) {
        return request({
            url: '/ecomorder/platform/transform/template/list',
            method: 'post',
            data,
        })
    },
    ecomOrderPlatformTransformTemplateDetailApi(data = {}) {
        return request({
            url: '/ecomorder/platform/transform/template/detail',
            method: 'post',
            data,
        })
    },
    ecomOrderPlatformTransformTemplateSaveApi(data = {}) {
        return request({
            url: '/ecomorder/platform/transform/template/save',
            method: 'post',
            data,
        })
    },
    ecomOrderPlatformTransformTemplateDelApi(data = {}) {
        return request({
            url: '/ecomorder/platform/transform/template/del',
            method: 'post',
            data,
        })
    },
    ecomOrderPlatformSelectTemplateApi(data = {}) {
        return request({
            url: '/ecomorder/ecom/platform/select/template',
            method: 'post',
            data,
        })
    },
})
